import script from "./OrganizerDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./OrganizerDetail.vue?vue&type=script&setup=true&lang=js"

import "./OrganizerDetail.vue?vue&type=style&index=0&id=0cbcd0d4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0cbcd0d4"]])

export default __exports__